import React from 'react'
import { SVGIconProps } from '../types'
const SvgAddToDrive = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M7.71 3.52 1.15 15l3.42 5.99 6.56-11.47zM13.35 15H9.73L6.3 21h8.24a5.93 5.93 0 0 1-1.19-6M20 16v-3h-2v3h-3v2h3v3h2v-3h3v-2zm.71-4.75L15.42 2H8.58v.01l6.15 10.77a5.99 5.99 0 0 1 5.98-1.53" />
  </svg>
)
export default SvgAddToDrive
